import {Component, inject, input, OnInit} from '@angular/core' // Lägg till OnInit
import {
  FormArray,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms'
import {MatButton, MatIconButton} from '@angular/material/button'
import {
  MatError,
  MatFormField,
  MatLabel,
  MatSuffix
} from '@angular/material/form-field'
import {MatIcon} from '@angular/material/icon'
import {MatInput} from '@angular/material/input'
import {MatOption, MatSelect} from '@angular/material/select'
import {SPBConstants} from '@sparbanken-syd/sparbanken-syd-theme'
import {OrientationService} from '../../../services/orientation.service'
import {RouteService} from '../../../services/route.service'

@Component({
  selector: 'spb-birth',
  templateUrl: './birth.component.html',
  styleUrl: '../kyc.component.scss',
  imports: [ReactiveFormsModule, MatFormField, MatLabel, MatSelect, MatOption, MatError, MatInput, MatButton, MatIcon, MatSuffix, MatIconButton]
})
export class BirthComponent implements OnInit {
  public birthForm = input.required<FormGroup>()
  protected readonly countryList = [...SPBConstants.CountryList]
    .toSorted(a => a.name === 'Sverige' ? -1 : 1)

  protected readonly orientationService = inject(OrientationService)
  protected readonly routeService = inject(RouteService)

  get citizenshipControls(): FormControl[] {
    return (this.birthForm().get('citizenship') as FormArray).controls as FormControl[]
  }

  public ngOnInit() {
    if (this.routeService.onHorseRoute()) {
      this.prefillSweden()
    }
  }

  public createCitizenship(): FormControl {
    return new FormControl(null, {
      nonNullable: true,
      validators: [Validators.required]
    })
  }

  public addCitizenship() {
    const citizenshipArray = this.birthForm().get('citizenship') as FormArray
    citizenshipArray.push(this.createCitizenship())


    setTimeout(() => {
      // Get all mat-select elements
      const selectElements: NodeListOf<HTMLElement> = document.querySelectorAll('mat-select')

      // Select the last one in the list and focus on it (the newly added one)
      selectElements[selectElements.length - 1]?.focus()
    })
  }

  /**
   * I don't why, but I can't get this to work exactly as it should
   * (it always removes the last in the array)
   * @param index
   */
  public removeCitizenship(index: number) {
    const citizenshipArray = this.birthForm().get('citizenship') as FormArray
    citizenshipArray.removeAt(index)
  }

  private prefillSweden() {
    const form = this.birthForm()
    const birthCountryControl = form.get('birthCountry')
    if (birthCountryControl && !birthCountryControl.value) {
      birthCountryControl.setValue('Sverige')
    }

    const citizenshipArray = form.get('citizenship') as FormArray
    if (citizenshipArray.length > 0) {
      const firstCitizenship = citizenshipArray.at(0)
      if (!firstCitizenship.value) {
        firstCitizenship.setValue('Sverige')
      }
    }
  }
}
